import { render, staticRenderFns } from "./RegisterError.vue?vue&type=template&id=6798b849&scoped=true&"
import script from "./RegisterError.vue?vue&type=script&lang=js&"
export * from "./RegisterError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6798b849",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VAlert,VCard,VCardText})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6798b849')) {
      api.createRecord('6798b849', component.options)
    } else {
      api.reload('6798b849', component.options)
    }
    module.hot.accept("./RegisterError.vue?vue&type=template&id=6798b849&scoped=true&", function () {
      api.rerender('6798b849', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/registration/RegisterError.vue"
export default component.exports